import { render, staticRenderFns } from "./PortalAccountModal.vue?vue&type=template&id=1dd78790&scoped=true&"
import script from "./PortalAccountModal.vue?vue&type=script&lang=js&"
export * from "./PortalAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./PortalAccountModal.vue?vue&type=style&index=0&id=1dd78790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd78790",
  null
  
)

export default component.exports